export const SET_CUSTOM_COLUMNS = 'SET_CUSTOM_COLUMNS';
export type SET_CUSTOM_COLUMNS = typeof SET_CUSTOM_COLUMNS;